import './scrolling-usps.scss';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin( ScrollTrigger );

function initInfiniteTicker() {

	const ticker = document.querySelector( '.js-ticker' );

	if ( ! ticker ) {
		return;
	}

	const content = ticker.innerHTML;
	ticker.innerHTML = Array( 6 ).fill( `<div class="ticker-track">${content}</div>` ).join( '' );

	// Batch DOM read
	const tracks = ticker.querySelectorAll( '.ticker-track' );

	// Only read offsetWidth once DOM is ready
	const trackWidth = tracks[0].offsetWidth;

	// Batch DOM write
	ticker.style.width = `${trackWidth * tracks.length}px`;

	// GSAP infinite tween with modifiers for seamless loop
	let tween = gsap.to( tracks, {
		x: `-=${trackWidth}`,
		duration: 30,
		ease: 'none',
		repeat: -1,
		modifiers: {
			x: gsap.utils.unitize( x => parseFloat( x ) % trackWidth ),
		},
	} );

	const baseSpeed = 1;
	tween.timeScale( baseSpeed );

	// Throttle scroll event
	let ticking = false;
	let lastTime = null;
	let lastTimestamp = null;
	let resetTimeout;

	function onScroll() {

		if ( ! ticking ) {
			window.requestAnimationFrame( updateTickerSpeed );
			ticking = true;
		}

	}

	function updateTickerSpeed() {

		const now = performance.now();
		const newY = window.scrollY;

		if ( lastTime === null || lastTimestamp === null ) {
			lastTime = newY;
			lastTimestamp = now;
			ticking = false;
			return;
		}

		const deltaY = newY - lastTime;
		const deltaT = ( now - lastTimestamp ) / 1000;

		const velocity = Math.abs( deltaY / deltaT );
		const minSpeed = baseSpeed;
		const maxSpeed = 5;
		let speed = baseSpeed + velocity / 500;
		speed = Math.max( minSpeed, Math.min( maxSpeed, speed ) );

		tween.timeScale( speed );

		clearTimeout( resetTimeout );
		resetTimeout = setTimeout( () => {
			gsap.to( tween, { timeScale: baseSpeed, duration: 1, ease: 'none' } );
		}, 300 );

		lastTime = newY;
		lastTimestamp = now;
		ticking = false;

	}

	window.addEventListener( 'scroll', onScroll );

}

document.addEventListener( 'DOMContentLoaded', function() {
	initInfiniteTicker();
} );